<template>
  <div>
    <v-card
      v-if="compType"
      v-model="playVal"
      elevation="0"
      :class="cardClasses"
    >
      <!-- <v-toolbar color="black" dark>
          <span>{{ playerName }}</span>
          <v-spacer></v-spacer>
          
      </v-toolbar> -->
      <!-- <v-btn @click="closeBtn" outlined small class="ma-4" style="position: absolute;z-index: 22;">
            섬네일 편집
          </v-btn> -->
      <div :class="videoContainerClasses" ref="videoContainer">
          <!-- <iframe ref="iframe" scrolling="no" :src="playUrl"  frameborder="0" allowfullscreen @load="initPlay" @playing="loadPlay"></iframe> -->
          <iframe ref="iframe" scrolling="no" :src="playUrl"  frameborder="0" allowfullscreen></iframe>
      </div>
    </v-card>

    <v-dialog v-if="!compType" v-model="playVal" persistent max-width="700px" @show="setIframeSrc">
      <v-toolbar color="black" dark>
          <span>{{ playerName }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeBtn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
      </v-toolbar>
      <div :class="videoContainerClasses" ref="videoContainer">
          <!-- <iframe ref="iframe" scrolling="no" :src="playUrl" frameborder="0"   playsinline="true" webkit-playsinline="true" @load="initPlay" @playing="loadPlay"
          allowfullscreen allow="autoplay" allowcontrols="true"></iframe> -->
          <iframe ref="iframe" scrolling="no" :src="playUrl" frameborder="0"   playsinline="true" webkit-playsinline="true" 
          allowfullscreen allow="autoplay" allowcontrols="true"></iframe>
      </div>
    </v-dialog>
  </div>
</template>
  
  <script>
  export default {
    props: {
        compType: {
            type: Boolean,
            require: true,
        },
        closeVideo: {
            type: Function,
            required: true
        },
        playerName: {
            type: String,
            require: true
        },
        playVal: {
            type: Boolean,
            default: false
        },
        playUrl: {
            type: String,
            require: true,
        },
        poster: {
          type: String,
        }
    },
    data() {
      return {
      };
    },
    mounted() {
      // console.log("poster 확인 => ", this.poster)
    },
    methods: {
      closeBtn() {
        // this.$emit('closeVideo');
          return this.closeVideo();
      },
      setIframeSrc(){
        //console.log("setIframeSrc")
        this.$nextTick(() => {
          this.$refs.iframe.src = this.playUrl;
        });
      },
      initPlay(){
          // console.log("로드 플레이 (modify) setting")
          // console.log("initPlay 1", this.poster);
          const iframeData = this.$refs.iframe;
          iframeData.onload = () => {
              // console.log("iframe 로드");
              // const video = iframe.contentWindow.document.querySelector('video');
              // if (!video) return;

              // if(this.poster == null || this.poster == ''){
              //   video.poster = "/streamon.png"
              // } else {
              //   video.poster = this.poster;
              // }
              const video = iframe.contentWindow.document.querySelector('video');
              if (!video) return;

              if (this.poster == null || this.poster == '') {
                  video.poster = "/streamon.png";
              } else {
                  video.poster = this.poster;
              }

              // console.log("initPlay", this.poster);
          };

      },
      resizeVideo(){
        console.log("resizeVideo setting")
        const iframe = this.$refs.iframe;
    
        const video = iframe.contentWindow.document.querySelector('video');
        if (!video) return;

        if(this.poster == null || this.poster == ''){
          video.poster = "/streamon.png";
        }
        video.poster = this.poster;

        console.log("resizeVideo iframe", iframe);
        console.log("resizeVideo video", video);


        video.autoplay = true;
        video.play();

      },
      loadPlay(){
          console.log("로드 플레이 (modify)")
          console.log("loadPlay 1", this.poster);
          const iframe = this.$refs.iframe;
          const video = iframe.contentWindow.document.querySelector('video');
          if (!video) return;

          if(this.poster == null || this.poster == ''){
            video.poster = "/streamon.png"
          } else {
            video.poster = this.poster;
          }

          console.log("loadPlay", this.poster);

          video.muted = false;
          video.autoplay = true;
          // video.play();
          video.addEventListener('loadedmetadata', () => {
              //video.play();
          });          

          // const iframe = this.$refs.iframe;
          // if (!iframe || !iframe.contentWindow || !iframe.contentWindow.document) return;
          // iframe.contentWindow.postMessage({ message: 'playVideo' }, '*');

          // window.addEventListener('message', event => {
          //     if (event.data === 'playVideo') {
          //         console.log("event.data => ", event.data)
          //         const video = iframe.contentWindow.document.querySelector('video');
          //         if (!video) return;
          //         if (video) {
          //             video.autoplay = true;
          //             video.play();
          //         } else {
          //             console.error('영상을 찾을 수 없습니다.');
          //         }
          //     }
          // });
      },
    },
    computed: {
      videoContainerClasses() {
        return [
          'video-container',
          this.compType ? 'video-container--fixed' : 'video-container--ratio',
        ];
      },
      cardClasses() {
        return {
          'asset-player-card': true,
          'asset-player-card--inline': this.compType,
        };
      },
    },
  
  }
  </script>
  
  <style scoped>
  .selected {
    background-color: #f0f0f0;
  }
  
  .asset-player-card {
    width: 100%;
  }

  .asset-player-card--inline {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .video-container {
    position: relative;
    width: 100%;
    overflow: hidden;
    background: #000;
  }

  .video-container--ratio {
    padding-bottom: 56.25%;
    height: 0;
  }

  .video-container--fixed {
    flex: 1 1 auto;
    height: 100%;
    padding-bottom: 0;
  }

  .video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  
  .button-icon {
    background-image: url('@/styles/assets/onerepeat_icon.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 24px;
    height: 24px;
    border: none;
    cursor: pointer;
  }
  
  .image-container {
    position: relative;
    background-color: black;
    width: 107px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  </style>
  
